import { createGlobalStyle } from 'styled-components';
import MarkW1GBook from '../fonts/Mark-W1G-Book.otf';
import MarkW1GBold from '../fonts/Mark-W1G-Bold.otf';

export default createGlobalStyle`
  
@font-face {
            font-family: MarkW1G;
            src: url(${MarkW1GBook}) format('opentype');
        }
        @font-face {
            font-family: MarkW1G;
            font-weight: bold;
            src: url(${MarkW1GBold}) format('opentype');
        }

body{
  font-family: 'MarkW1G', sans-serif;
}
body * {
  font-family: 'MarkW1G', sans-serif;
  font-size: 14px;
  font-style: normal;
}
`;
